import { capitalize } from "lodash";

export const getParentingButtons = ({ clientLabel = "Client", exLabel = "Former Spouse" }) => [
  {
    value: "CLIENT",
    label: clientLabel,
  },
  {
    value: "SHARED",
    label: "Shared",
  },
  {
    value: "EX",
    label: exLabel,
  },
];

export const buttons = [
  {
    value: true,
    label: "Yes",
  },
  {
    value: false,
    label: "No",
  },
];

export const getSupportedByButtons = ({ exLabel, clientLabel, isProfessional, isSeparated }) => [
  {
    value: "CLIENT",
    label: isProfessional ? capitalize(clientLabel) : "You",
  },
  {
    value: "EX",
    label: isProfessional ? capitalize(exLabel) : isSeparated ? "Former Spouse" : "Spouse",
  },
];

export const supportTypeButtons = [
  {
    value: "GUIDELINE",
    label: "Guideline",
  },
  {
    value: "ADULT",
    label: "s. 3(2)(b)",
  },
  {
    value: "OTHER",
    label: "Other",
  },
];

export const getClaimBenefitButtons = ({ clientLabel = "Client", exLabel = "Former Spouse" }) => [
  {
    value: "CLIENT",
    label: capitalize(clientLabel),
  },
  {
    value: "SHARED",
    label: "Shared",
  },
  {
    value: "EX",
    label: capitalize(exLabel),
  },
  {
    value: "NONE",
    label: "None",
  },
  {
    value: null,
    label: "Auto",
  },
];

export const getClaimDeductionButtons = ({ clientLabel = "Client", exLabel = "Former Spouse" }) => [
  {
    value: "CLIENT",
    label: capitalize(clientLabel),
  },
  {
    value: "EX",
    label: capitalize(exLabel),
  },
  {
    value: "NONE",
    label: "None",
  },
  {
    value: null,
    label: "Auto",
  },
];

export const relationshipButtons = [
  {
    value: true,
    label: "Yes",
  },
  {
    value: false,
    label: "No",
  },
];

export const dependentButtons = [
  {
    value: true,
    label: "Yes",
  },
  {
    value: false,
    label: "No",
  },
];
